import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="agencyAgreement";
export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function insert(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}`,
     method: 'post',
     data:parameter
   })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}
export function selectOne(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get',
  })
}


export function deleteById(id){
  console.log("ids",id)
  return axios({
    url: `/ws/${moduleName}/deleteById/${id}`,
    method: 'delete',
  })
}

export function updateStatus(id){
  console.log("ids",id)
  return axios({
    url: `/ws/${moduleName}/updateStatus/${id}`,
    method: 'put',
  })
}

export function selectByCompanyId(key){
  console.log("key",key)
  return axios({
    url: `/ws/${moduleName}/selectByCompanyId/${key}`,
    method: 'get',
  })
}

export function selectByOnwerIdAndMansionId(ownerId,mansionId){
  return axios({
    url: `/ws/${moduleName}/selectByOnwerIdAndMansionId/${ownerId}/${mansionId}`,
    method: 'get',
  })
}

export default {
  insert,
  update,
  selectAll,
  selectOne,
  updateStatus,
  deleteById,
  selectByCompanyId,
  selectByOnwerIdAndMansionId,
}